import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ObservatoryService } from '@services/services.module';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-server',
  templateUrl: './server.component.html',
  styleUrls: ['./server.component.scss']
})
export class ServerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private observatory: ObservatoryService
  ) { }

  ngOnInit() {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
    this.observatory.setData('loader', false);
  }

}
